module.exports = __webpack_public_path__ + "img/logo-limonist.ad2ed2b7.png";